// extracted by mini-css-extract-plugin
module.exports = {"root":"AudioPlayerWrapper_root__oyXLY"};